export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/opencart.8733e3f.svg";